import PropTypes from "prop-types";

function ViewToggle({ value, setValue, labels = [], booleanComponent = true }) {
    const handleChange = (value) => {
        setValue(value);
    };
    return (
        <div
            style={{
                zIndex: 10,
                // width: "100%",
            }}
            className="table-chart-toggle-container"
        >
            <div
                // onClick={() => setValue(true)}
                onClick={() => handleChange(booleanComponent ? true : labels?.[0])}
                style={{
                    width: "100%",
                    letterSpacing: "0.4px",
                    whiteSpace: "nowrap",
                    padding: "5px",
                }}
                className={(booleanComponent && value) || (!booleanComponent && value === labels?.[0]) ? "liner-light-blue-background color-white bold-content" : "color-blue"}
                // className={(!booleanComponent && value === labels?.[0] )? "liner-light-blue-background color-white bold-content" : "color-blue"}
            >
                {labels?.[0] || "Label 1"}
            </div>
            <div
                // onClick={() => setValue(false)}
                onClick={() => handleChange(booleanComponent ? false : labels?.[1])}
                style={{
                    width: "100%",
                    letterSpacing: "0.4px",
                    whiteSpace: "nowrap",
                    padding: "5px",
                }}
                // className={!value ? "liner-light-blue-background color-white bold-content" : "color-blue"}
                className={(booleanComponent && !value) || (!booleanComponent && value === labels?.[1]) ? "liner-light-blue-background color-white bold-content" : "color-blue"}
            >
                {labels?.[1] || "Label 2"}
            </div>
        </div>
    );
}

ViewToggle.propTypes = {
    value: PropTypes.number,
    setValue: PropTypes.func,
    labels: PropTypes.array,
    booleanComponent: PropTypes.boolean,
};

export default ViewToggle;
